import React, { useEffect, useState } from "react";
import './table.css';
import Filed from "./Filed";
import { removeFrontZero, roundNumber } from "../../util/util";

const Table = ({data}) => {
    const toFixedDecimal = (value) => {
        if (isNaN(value)) {
            return '';
        }
        return parseFloat(value).toFixed(2);
    }
    return (
        <div className="overflow-y-auto border-gray-400 border-b min-w-full min-h-44 p-3">
            <div className="flex">
                <Filed text={"호기"} style={"bg-blue-400 text-white"} />
                <Filed text={"지종"} style={"bg-blue-400 text-white"} />
                { 
                    data && data.map((v, index) => {
                        return <Filed key={index} text={ v.PKCDXX ? `${v.PKCDXX.replace("원지", "")} ${removeFrontZero(v.BSSWGH)}` : ''} style={"bg-blue-400 text-white"} />
                    })
                }
            </div>
            <div className="flex">
                <div className="flex-col">
                    <Filed text={`PM2`} style={"min-h-14 bg-blue-400 text-white text-2xl content-center align-middle justify-center items-center"}/>
                    <Filed text={`PM3`} style={"min-h-14 bg-blue-400 text-white text-2xl content-center align-middle justify-center items-center"}/>
                </div>
                <div className="flex-col">
                    <Filed text={"CD Index"} style={"bg-blue-400 text-white h-7"}/>
                    <Filed text={"파강 Index"} style={"bg-blue-400 text-white h-7"}/>
                    <Filed text={"CD Index"} style={"bg-blue-400 text-white h-7"}/>
                    <Filed text={"파강 Index"} style={"bg-blue-400 text-white h-7"}/>
                </div>
                {
                    data.length > 0 &&
                    data.map((v, index) => {
                        return (
                            <div className="flex-col">
                                <Filed text={ v.data ? toFixedDecimal(v.data["2_CDINDX"]) : ""} style={"bg-white h-7"} />
                                <Filed text={ v.data ? toFixedDecimal(v.data["2_PAINDX"]) : ""} style={"bg-white h-7"} />
                                <Filed text={ v.data ? toFixedDecimal(v.data["3_CDINDX"]) : ""} style={"bg-white h-7"} />
                                <Filed text={ v.data ? toFixedDecimal(v.data["3_PAINDX"]) : ""} style={"bg-white h-7"} />    
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Table;